// extracted by mini-css-extract-plugin
module.exports = {"result":"PermissionContainer_result__Rxo20"};